import React from 'react';
// Images import kiya hua hai, jaise tumne diya hai
import specialChildCareImg from './images/cheerful-boy-disability-rehabilitation-center-260nw-524271736.webp';
import childMindsGrowImg from './images/images.jpeg';
import childCareImg from './images/images (8).jpeg';
import teachingChildrenImg from './images/download (2).jpeg';

const programsData = [
  {
    title: 'Special Child Care',
    description: 'A dedicated program for special needs children to help them thrive and develop.',
    image: specialChildCareImg,
  },
  {
    title: 'Child Minds Grow',
    description: 'Engaging activities and learning experiences designed to stimulate young minds.',
    image: childMindsGrowImg,
  },
  {
    title: 'Child Care Programs',
    description: 'Comprehensive child care solutions focusing on nurturing and education.',
    image: childCareImg,
  },
  {
    title: 'Teaching Children',
    description: 'Innovative teaching strategies to ensure children learn effectively and enjoyably.',
    image: teachingChildrenImg,
  },
];

const Programs = () => {
  return (
    <>
      <section className="programs-section py-16 px-6 bg-gray-50">
        <div className="container mx-auto max-w-7xl">
          <div className="heading-container text-center mb-14">
            <h2 className="text-5xl font-extrabold text-gray-900 tracking-tight">
              Our Child Care Programs
            </h2>
            <p className="text-lg md:text-xl text-gray-600 mt-4 max-w-3xl mx-auto">
              Explore our specialized programs designed for the holistic development of children.
            </p>
          </div>

          <div className="programs-content grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            {programsData.map((program, index) => (
              <div
                key={index}
                className="program bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300 transform hover:-translate-y-1 hover:scale-105 cursor-pointer"
              >
                <img
                  src={program.image}
                  alt={program.title}
                  className="w-full h-52 object-cover rounded-lg mb-6"
                />
                <h3 className="text-2xl font-semibold text-gray-900 mb-2">{program.title}</h3>
                <p className="text-gray-700 leading-relaxed">{program.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Programs;
